// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EHB4","controls":"styles_controls__2xvo_","charLimit":"styles_charLimit__J6Bl3","input":"styles_input__1YlTP","send":"styles_send__3HlpN"};